const FooterUX = () => {
    if ($('footer.main-footer').length <= 0) return null;

    const $parent = $("footer.main-footer");
    const $fieldWrapper = $parent.find('.field-wrapper');
    const $mobToggle = $parent.find('.mob-toggle .footer-heading');
    const $mobileAnchors = $parent.find('.mob-toggle > h3 > a');
    
    const currUrl = window.location.href;
    const formConfirm = currUrl.split('.com/')[1];

    //new subscriber
    if ($fieldWrapper.hasClass('has-errors') === false) {
        if (window.location.search === '?customer_posted=true' || formConfirm === '?customer_posted=true#FooterNewsletter' || window.location.search === '?contact%5Btags%5D=newsletter&form_type=customer') {
            $fieldWrapper.after(`<span class="form-submit-success">Thank you for your submission! We will keep in touch. <svg aria-hidden="true" focusable="false" class="icon icon-success" viewBox="0 0 13 13">
            <path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"/>
            <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"/>
            <path d="M4.10645 6.7688L6.13766 8.62553" stroke="white">
          </svg>
          </span>`)
        }
    }


    if ($(window).width() <= 1200) {
        //unclickable anchors when accordion
        $mobileAnchors.click(function(ev) {
            ev.preventDefault();
        })

        $mobToggle.click(function() {
            $(this).toggleClass('toggled');
            $(this).next('.mob-dropdown').stop().slideToggle(400);
        });
        $parent.addClass('mob-version')
    }

    $(window).resize(function() {
        if ($(window).width() <= 1200) {
            if ($parent.hasClass('mob-version') == false) {
                //unclickable anchors when accordion
                $mobileAnchors.click(function(ev) {
                    ev.preventDefault();
                })

                $mobToggle.click(function() {
                    $(this).toggleClass('toggled');
                    $(this).next('.mob-dropdown').stop().slideToggle(400);
                });
                $parent.addClass('mob-version')
            }
        }
    })
}

export default FooterUX